import merge from 'deepmerge'
import MethodMessages from './messages'
import MethodPermissionMessages from './permissions/MethodPermissionMessages'

const messages = merge.all([
    MethodMessages,
    MethodPermissionMessages
])

export default messages
